export default __webpack_public_path__ + "static/media/Inter-ExtraLight.0a26b1ef.woff2";